import BioComponent from '../components/BioComponent';

const Bio = () => {

    return  <BioComponent/>
}

export default Bio;

